import _toConsumableArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { data_default } from "./chunk-UZSG2J5O.mjs";
import { config } from "./chunk-5XJQLH56.mjs"; // src/utils/CountryCallingCodes/index.ts

import parsePhoneNumber, { getCountryCallingCode, getExampleNumber as _getExampleNumber, isValidPhoneNumber } from "libphonenumber-js";
import examples from "libphonenumber-js/examples.mobile";
import _ from "lodash";
var isCnApp = config.isCnApp;

var dataGroupByAlphabet = _.groupBy(data_default, function (country) {
  var _country$name;

  return country === null || country === void 0 ? void 0 : (_country$name = country.name) === null || _country$name === void 0 ? void 0 : _country$name[0];
});

var alphabetKeys = _.keys(dataGroupByAlphabet);

var defaultCountryIso = isCnApp ? "cn" : "tw";

var defaultCountry = _.find(data_default, {
  iso: defaultCountryIso
});

var hotIsos = ["tw", "us", "uk", "ca", "hk", "my", "sg", "jp", "vn", "cn"];
var modalOptionsByLanguage = [{
  title: "popular",
  enTitle: "Popular",
  zh_CNTitle: "\u70ED\u95E8",
  zh_TWTitle: "\u71B1\u9580",
  data: _.map(hotIsos, function (iso) {
    return _.find(data_default, {
      iso: iso
    });
  })
}].concat(_toConsumableArray(_.map(alphabetKeys, function (key) {
  return {
    title: key,
    data: dataGroupByAlphabet[key]
  };
})));
var PhoneUtil = {
  isValidNumber: function isValidNumber(n, iso) {
    var countryCode = iso.toUpperCase();
    return isValidPhoneNumber("".concat(getCountryCallingCode(countryCode), " ").concat(n), countryCode);
  },
  getInternationalFormat: function getInternationalFormat(n, iso) {
    var _phoneNumber$formatIn;

    var countryCode = iso.toUpperCase();
    var phoneNumber = parsePhoneNumber("".concat(getCountryCallingCode(countryCode), " ").concat(n), countryCode);
    return phoneNumber === null || phoneNumber === void 0 ? void 0 : (_phoneNumber$formatIn = phoneNumber.formatInternational()) === null || _phoneNumber$formatIn === void 0 ? void 0 : _phoneNumber$formatIn.replace(/\s/g, "");
  },
  getInternationalFormatWithSpace: function getInternationalFormatWithSpace(n, iso) {
    var countryCode = iso.toUpperCase();
    var phoneNumber = parsePhoneNumber("".concat(getCountryCallingCode(countryCode), " ").concat(n), countryCode);
    return phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.formatInternational();
  },
  getExampleNumber: function getExampleNumber(iso) {
    var onlyNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "NATIONAL";
    var countryCode = iso.toUpperCase();

    var number = _getExampleNumber(countryCode, examples);

    var formatted = (number === null || number === void 0 ? void 0 : number.format(format)) || "";
    return onlyNumber ? formatted.replace(/\D/g, "") : formatted;
  }
};
var CountryCallingCodes = {
  defaultCountry: defaultCountry,
  PhoneUtil: PhoneUtil,
  modalOptionsByLanguage: modalOptionsByLanguage
};
var CountryCallingCodes_default = CountryCallingCodes;
export { CountryCallingCodes_default };